import React from "react";
import { Turnstile, TurnstileInstance } from "@marsidev/react-turnstile";
import Logger from "../singletons/Logger";

export interface ITurnstileContext {
  consume: () => string | undefined;
}

export const TurnstileContext = React.createContext<ITurnstileContext>({
  consume: () => undefined,
});

export const useTurnstileContext = () => React.useContext(TurnstileContext);

export const TurnstileProvider = ({ children }: { children: React.ReactNode }) => {
  const ref = React.useRef<TurnstileInstance | undefined>();

  const consume = React.useCallback(() => {
    const token = ref.current?.getResponse();

    ref.current?.reset();

    return token;
  }, [ref]);

  return (
    <TurnstileContext.Provider value={{ consume }}>
      {children}

      {process.env.GATSBY_TURNSTILE_SITE_KEY && (
        <Turnstile
          siteKey={process.env.GATSBY_TURNSTILE_SITE_KEY}
          ref={ref}
          onExpire={() => {
            ref.current?.reset();
          }}
          onError={(err) => {
            Logger.warn(`Turnstile error: ${err}. Attempting to reset...`);
            ref.current?.reset();
          }}
        />
      )}
    </TurnstileContext.Provider>
  );
};
